import { useSelector } from "react-redux";
import { H2RCheckbox, H2RInput, ImageUploader } from "../../imports";
import { H2RSelect } from "../../imports";
import { ImagePreview } from "../FormElements";

export const GraphicEditor = ({ cue, media, onUpdate }) => {
	const cloud = useSelector((state) => state.rundown.cloud) || false;

	return (
		<>
			<H2RSelect
				selected={cue.backgroundFit || "cover"}
				label="Image size"
				options={[
					{
						label: "Grow to fill screen",
						value: "cover",
					},
					{
						label: "Shrink to fit",
						value: "contain",
					},
				]}
				onChange={(value) => {
					return onUpdate({ backgroundFit: value });
				}}
			/>

			<H2RInput
				label="Name"
				value={cue.name}
				onChange={(value) => {
					onUpdate({ name: value });
				}}
			/>

			{cue.imageFromUrl ? (
				<H2RInput
					label="Image URL"
					value={cue.url}
					placeholder={`https://media.h2r.graphics/image.png`}
					onChange={(change) => {
						onUpdate({ url: change });
					}}
				/>
			) : (
				<H2RSelect
					selected={cue.filename}
					label="Image"
					options={
						media.length === 0
							? [
									{
										label: "Add images in the Media tab",
										value: ``,
										disabled: true,
									},
							  ]
							: [
									...media
										.filter((item) => item.mimetype.includes("image"))
										.filter((item) => !item.partOf)
										.sort((a, b) => {
											if(a.originalname.toUpperCase() < b.originalname.toUpperCase()) { return -1; }
											if(a.originalname.toUpperCase() > b.originalname.toUpperCase()) { return 1; }
											return 0;
										})
										.map((item) => {
											return {
												label: item.originalname,
												value: item.filename,
											};
										}),
							  ]
					}
					onChange={(value) => {
						return onUpdate({ filename: value });
					}}
				/>
			)}
			{cue.imageFromUrl ? 
				<ImagePreview image={cue.url} fromUrl={true} />
			:
				<ImagePreview image={cue.filename} />
			}
			<H2RCheckbox
				checked={cue.imageFromUrl || false}
				label="Image from URL"
				checkboxLabel="Use online image URL"
				onChange={(checked)=> onUpdate({ imageFromUrl: checked })}
			/>
		</>
	);
};

export const GraphicCueContent = ({ cue }) => {
	return (
		<div className="overflow-ellipsis max-w-xs md:max-w-sm lg:max-w-lg whitespace-nowrap overflow-hidden">
			<span className="font-semibold">{cue.name || "Image"}</span>
		</div>
	);
};
